const UserMenuInputComponent = ({ ...rest }) => {
  return (
    <input
      className="mb-2 p-2 border border-gray-300 rounded placeholder:text-xs shadow-[0_2px_4px_rgba(0,0,0,0.1)]"
      {...rest}
    />
  );
};

export default UserMenuInputComponent;
